export app          from 'containers/App/store/reducers';
export assignments  from 'containers/AssignmentsPage/store/reducers';
export auth         from 'containers/AuthPages/store/reducers';
export content      from 'containers/ContentPage/store/reducers';
export groups       from 'containers/UsersPage/store/groups/reducers';
export pinpoints    from 'containers/PinpointsPage/store/reducers';
export reports      from 'containers/ReportsPage/store/reducers';
export users        from 'containers/UsersPage/store/users/reducers';



// WEBPACK FOOTER //
// ./src/store/reducers.js